// extracted by mini-css-extract-plugin
export default {"section":"forumThread_section__7vPQl","title":"forumThread_title__tw9M2","list":"forumThread_list__Cl4ZI"};